import { Component, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    constructor(private title: Title, private meta: Meta, @Inject(DOCUMENT) private document: Document) {
        this.title.setTitle("Főoldal | DIDO Vendégház");
        this.meta.updateTag({
            name: "description",
            content: "DIDO Vendégház főoldala"
        });
        
        let canonical = this.document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
        if (!canonical) {
            canonical = this.document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            this.document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', 'https://www.didovendeghaz.hu/');

        // add alternate link tag (use DOM directly for link elements)
        const altLink = this.document.createElement('link');
        altLink.setAttribute('rel', 'alternate');
        altLink.setAttribute('hreflang', 'x-default');
        altLink.setAttribute('href', 'https://example.com/');
        this.document.head.appendChild(altLink);



        this.meta.addTags([
            { property: 'og:title', content: 'Főoldal | DIDO Vendégház' },
            { property: 'og:description', content: 'DIDO Vendégház főoldala' },
            { property: 'og:image', content: 'https://www.didovendeghaz.hu/assets/og-image.jpg' },
            { property: 'og:url', content: 'https://www.didovendeghaz.hu/' },
            { property: 'og:type', content: 'website' }
        ]);

        this.meta.updateTag({ name: 'keywords', content: 'dido, vendégház, szállás, pihenés, természet, horgászat, foglalás, foglalj, dido vendégház, szajk, szajki-tavak, apartman, szoba' });
    }
}
